import connectRefinementList from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';

export default connectRefinementList((renderOptions) => {
	window.items = window.items || {};
	const { items: liveItems, refine, createURL, widgetParams, results } = renderOptions;
	const { taxonomy, type = 'details', initialItems = [] } = widgetParams;
	const { singular } = strl_vars['cpt_taxonomies'][taxonomy] || {};

	// Seed the dropdown from the server-provided WordPress taxonomy terms until
	// Algolia's first response arrives, so the menus render immediately without
	// an extra round-trip. Once we have live results, Algolia's items win
	// (they carry counts and current refinement state).
	const items =
		results || liveItems.length > 0
			? liveItems
			: initialItems.map((item) => ({
					value: item.value,
					label: item.label,
					count: null,
					isRefined: false,
				}));

	const el =
		widgetParams.container instanceof Element
			? widgetParams.container
			: document.querySelector(widgetParams.container);

	if (el) {
		if (type === 'details') {
			el.innerHTML = `
				<details class="bg-white mb-4" ${window.items['refinement-' + taxonomy]?.isOpened ? 'open' : ''}>
					<summary>
						${singular}
					</summary>
					<div>
						<ul class="mb-0 flex flex-col gap-4">
							${items
								.map(
									(item) => `
										<li class="list-none">
											<a
												href="${createURL(item.value)}"
												data-value="${item.value}"
												class="flex items-center gap-2 no-underline"
											>
												${item.isRefined ? '<i class="fa-solid fa-check-square text-semantic-success"></i>' : '<i class="fa-regular fa-square"></i>'}
												${item.label}${item.count != null ? ` <span class="bg-primary-20 px-1.5 py-1 rounded-sm leading-none text-[13px]">${item.count}</span>` : ''}
											</a>
										</li>
									`
								)
								.join('')}
						</ul>
					</div>
				</details>
		`;
		} else if (type === 'select') {
			el.innerHTML = `
				<select name="${taxonomy}">
					<option value="">${singular}</option>
					${items
						.map(
							(item) => `
						<option value="${item.value}" ${window.items['select-' + taxonomy] == item.value ? 'selected' : ''}>${item.label}</option>
					`
						)
						.join('')}
				</select>
			`;
		}
	}

	[...el.querySelectorAll('a')].forEach((element) => {
		element.addEventListener('click', (event) => {
			event.preventDefault();
			window.items['refinement-' + taxonomy] = {
				isOpened: true,
			};
			refine(event.currentTarget.dataset.value);
		});
	});

	el.querySelector('select')?.addEventListener('change', (e) => {
		const value = e.target.value;

		if (!!value) {
			window.items['select-' + taxonomy] = value;
			refine(value);
		}
	});
});
